export const CatalogPage = defineAsyncComponent(
  () => import('@/pages/catalog/ui/@platform/index.vue'),
);
